module.exports = __webpack_public_path__ + "img/i_h2_function3.6ff01d5f.svg";